import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../api/auth/authSlice";
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { Link } from "react-router";

export function PerfilContainer() {

    const user = useSelector(selectCurrentUser);

    //const {} = useForm();

    const height="h-[35px]"
    const width="w-[300px]"

    return (
        <div className="h-full w-full p-3">

            <div>

                <div className="mb-4">
                    <p className="text-xl font-semibold">Informacion del usuario</p>
                </div>


                <div className="flex gap-xs-10">

                    <div className="flex flex-col items-center mx-4 border-0 border-green-800">
                        <div className="w-[120px] h-[120px] bg-gray-800 rounded-full"></div>

                        <div className="flex items-center gap-x-2 mt-2">
                            <button>
                                <div className="border-2 border-gray-400 rounded-full py-1 px-2 h-[32px] w-full hover:bg-gray-100 ">
                                    <p className="font-semibold text-[13px]">Actualizar foto</p>
                                </div>
                            </button>

                            <button>
                                <div className="border-2 border-gray-400 rounded-full py-[4px] px-2 flex items-center hover:bg-gray-100 ">
                                    <DeleteRoundedIcon sx={{ height: 20, width: 20 }}/>
                                </div>
                            </button>
                        </div>

                    </div>

                    <div>

                        <div className="flex gap-x-4 mb-2">
                            <div>
                                <div className="grid">
                                    <label className="text-[13px] font-semibold">Nombre</label>
                                    <input 
                                        value={user?.nombre}
                                        className={`${width} ${height} rounded-[3px] border-gray-400 border px-2 
                                            font-semibold text-gray-600 text-sm`}
                                        type={"text"}/>
                                </div>
                            </div>
                            
                            <div>
                                <div className="grid">
                                    <label className="text-[13px] font-semibold">Usuario</label>
                                    <input 
                                        value={user?.username}
                                        className={`${width} ${height} rounded-[3px] border-gray-400 border px-2 
                                            font-semibold text-gray-600 text-sm`}
                                        type={"text"}/>
                                </div>
                            </div>
                        </div>


                        <div>
                            <div className="grid">
                                <label className="text-[13px] font-semibold">Correo</label>
                                <input 
                                    value={user?.email}
                                    className={`${width} ${height} rounded-[3px] border-gray-400 border px-2 
                                        font-semibold text-gray-600 text-sm`}
                                    type={"text"}/>
                            </div>
                        </div>

                    </div>

                </div>


            </div>

            <div className="border border-gray-500 my-8"></div>


            <div>
                <div className="mb-4">
                    <p className="text-xl font-semibold">Configuracion de la cuenta</p>
                </div>


                <Link
                    to={"/perfil/cambiar-password"}
                    className="no-underline text-black hover:text-black">
                    <button>
                        <div className="border-2 border-gray-400 rounded-full py-1 px-2 h-[32px] w-full hover:bg-gray-100">
                            <p className="font-semibold text-[13px]">Cambiar contraseña</p>
                        </div>
                    </button>
                </Link>

            </div>

        </div>
    );
}